import React from 'react';
import { clsx } from 'clsx';

interface TableFooterProps extends React.HTMLAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
}

export function TableFooter({ children, className, ...props }: TableFooterProps) {
  return (
    <tfoot 
      className={clsx("bg-gray-50", className)} 
      {...props}
    >
      {children}
    </tfoot>
  );
} 